import anime from 'animejs';
import eventHub from '../eventHub';

class PuzzleItem {
  constructor(item) {
    this.el = item;
    this.isLast = item.classList.contains('last');
    this.picture = item.querySelector('.c-puzzle-picture');
    this.startIndex = parseInt(item.dataset.index, 10);
    this.currentIndex = this.startIndex - 1;

    this.reset();
  }

  addEvents() {
    this.clickHandler = () => eventHub.$emit('clickPuzzleItem', this.startIndex);
    this.el.addEventListener('click', this.clickHandler);
  }

  hide() {
    this.el.style.opacity = 0;
    this.el.style.display = 'none'; // Ricordarsi di settarlo o non si potrà cliccare l'elemento che sta sotto
  }

  show() {
    this.el.style.display = 'block';
    anime({
      targets: this.$el, opacity: [0, 1], duration: 800, easing: 'easeInOutQuad',
    });
  }

  reset() {
    this.currentIndex = this.startIndex - 1;
    this.coord = {
      x: () => (this.currentIndex % 4),
      y: () => Math.floor(this.currentIndex / 4),
    };
    this.top = this.coord.y();
    this.left = this.coord.x();

    this.resize();
  }

  resize() {
    this.side = this.el.getBoundingClientRect().width;
    this.picture.style.backgroundPosition = `
      ${((this.startIndex - 1) % 4) * 33.3}% ${Math.floor((this.startIndex - 1) / 4) * 33.3}%
    `;
    this.el.style.left = `${this.left * 25}%`;
    this.el.style.top = `${this.top * 25}%`;
  }

  removeEvents() {
    this.el.removeEventListener('click', this.clickHandler);
  }

  get position() {
    return {
      x: this.top,
      y: this.left,
      index: this.currentIndex,
    };
  }

  set position(coord) {
    this.top = coord.y;
    this.left = coord.x;
    this.currentIndex = coord.currentIndex;
    this.el.style.left = `${coord.x * 25}%`;
    this.el.style.top = `${coord.y * 25}%`;
  }
}

export default PuzzleItem;
